<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<upload :formCreateInject="true" :fileList="file_underline" v-model="file_underline"  />
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		mixins: [modalMixins],
		props: {
			currentrow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				modal_model:false,
				modal_title: '线下核对凭证',
				modal_width: 500,
				modal_height: 300,
				file_underline:[]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				if(this.currentrow){
					this.modal_title = '线下核对凭证【'+this.currentrow.code+'】'
					this.file_underline = this.currentrow.file_underline?this.currentrow.file_underline:[]
				}
			},
			submit() {
				this.$emit('submit',{data:this.file_underline})
				
			}
		},
		components: {
			upload
		}
	}
</script>